import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';
import { Resolution } from '@toggle/toggle';

import { getPrices } from '~/services/price/price-service';

const QUERY_KEY_PRICE_HISTORY = 'QUERY_KEY_PRICE_HISTORY';

interface UsePriceHistoryProps {
  entityTag: string;
  resolution?: Resolution;
  dateFrom?: string;
  dateTo?: string;
  enabled?: boolean;
}

export const usePriceHistory = ({
  entityTag,
  resolution = '1D',
  dateFrom,
  dateTo,
  enabled = true,
}: UsePriceHistoryProps) =>
  useQuery({
    queryKey: [
      QUERY_KEY_PRICE_HISTORY,
      entityTag,
      resolution,
      dateFrom,
      dateTo,
    ],
    queryFn: () => getPrices({ entityTag, resolution, dateFrom, dateTo }),
    staleTime: getTimeTillEndOfDayMs(),
    enabled,
  });
